import React from "react";
import { Link } from "react-router-dom";
import { earlierWork, liveProducts } from "../platformContent";
import "./Main.css";

const ContentSection = () => {
  return (
    <div className="platform__content-section">
      <div className="uigrid">
        <div className="uigrid-8 platform__content-inner">
          <p>
            One core system for accounts, catalogues, orders, payments,
            inventory, notifications, and admin tooling. Each product is
            configured and extended for its market rather than built from scratch.
          </p>

          <h4>Capabilities</h4>
          <ul>
            <li>Customer and merchant onboarding</li>
            <li>Product catalogues and pricing</li>
            <li>Orders, checkout, and fulfilment</li>
            <li>Payments across multiple gateways</li>
            <li>Inventory and branch management</li>
            <li>Notifications and operational email</li>
            <li>Admin dashboards and mobile APIs</li>
          </ul>

          <h4>Products</h4>
          <div className="platform__card-list">
            {liveProducts.map((product) => (
              <div
                className="platform__card"
                id={product.slug}
                key={product.slug}
              >
                <h5>
                  {product.caseStudyPath ? (
                    <Link to={product.caseStudyPath}>{product.name}</Link>
                  ) : (
                    product.name
                  )}
                </h5>
                {product.intro.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
                <p className="platform__card-link">
                  <a
                    href={product.externalUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {product.externalUrl.replace(/^https?:\/\//, "")}
                  </a>
                  {product.caseStudyPath && (
                    <>
                      {" · "}
                      <Link to={product.caseStudyPath}>Case study</Link>
                    </>
                  )}
                </p>
              </div>
            ))}
          </div>

          <h4>Earlier work</h4>
          {earlierWork.map((item) => (
            <div className="platform__card" key={item.name}>
              <h5>
                <Link to={item.path}>{item.name}</Link>
              </h5>
              <p>{item.description}</p>
              <p className="platform__card-link">
                <a href={item.externalUrl} target="_blank" rel="noreferrer">
                  {item.externalUrl.replace(/^https?:\/\//, "")}
                </a>
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContentSection;
